module.exports = __webpack_public_path__ + "static/HyGenius_App_EN-e3fd640cc6e251f480ba354fc18c0354.png";